import React, { memo, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { Typography } from 'fronton-react';
import { MockStoreLinks } from '__mocks__';
import { Container, InstoreCategoryCard } from 'common/components';
import { getInstoreCategoryData } from 'utils';
import { selectCategories, selectSelectedStoreCode } from '../../../selectors';
import { OtherCategoriesSection, OtherCategoriesSlider, Wrapper } from './styles';

export const OtherCategories = memo(() => {
	const categories = useSelector(selectCategories);
	const selectedStoreCode = useSelector(selectSelectedStoreCode);
	const storeLink = useMemo(() => {
		return selectedStoreCode
			? MockStoreLinks.find(({ code }) => code === selectedStoreCode)?.link || null
			: null;
	}, [selectedStoreCode]);

	if (!categories) {
		return null;
	}

	return (
		<OtherCategoriesSection data-qa="other-categories-container">
			<Container>
				<Typography variant={'h3'} as="h3">
					Другие услуги
				</Typography>
				<Wrapper>
					<OtherCategoriesSlider>
						{categories.map(category => {
							const cardData = getInstoreCategoryData(category, storeLink);

							return (
								<InstoreCategoryCard
									key={`category-${category.name}`}
									type="other"
									{...cardData}
								/>
							);
						})}
					</OtherCategoriesSlider>
				</Wrapper>
			</Container>
		</OtherCategoriesSection>
	);
});
